import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '@estee/elc-base-theme';

export interface ISpinnerIconProps {
    className?: string;
    color?: string;
}

const Svg = styled.svg`
    animation: rotate 2s linear infinite;
    transform-origin: center center;
    width: 36px;
    height: 36px;

    @keyframes rotate {
        100% {
            transform: rotate(360deg);
        }
    }
`;

const Circle = styled.circle`
    stroke-dasharray: 150, 200;
    stroke-dashoffset: -10;
    animation: dash 1.5s ease-in-out infinite;
    stroke-linecap: round;

    @keyframes dash {
        0% {
            stroke-dasharray: 1, 200;
            stroke-dashoffset: 0;
        }
        50% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -35;
        }
        100% {
            stroke-dasharray: 89, 200;
            stroke-dashoffset: -124;
        }
    }
`;

const SpinnerIcon = (props: ISpinnerIconProps) => {
    return (
        <Svg viewBox="25 25 50 50" className={props.className}>
            <Circle
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke={props.color || Colors.black}
                stroke-width="2"
            />
        </Svg>
    );
};

export { SpinnerIcon };
